/**
 * @param themeData HarmonyThemeData
 * @returns An OfficeStartTheme used to create Fluent palette data
 */
export var officeStartThemeFromBase = function (themeData) {
    var _a, _b;
    return {
        mode: themeData.mode,
        themeId: themeData.id,
        lightBrandColors: {
            themeDarker: themeData.colors.Darker,
            themeDark: themeData.colors.Dark,
            themeDarkAlt: themeData.colors.DarkAlt,
            themePrimary: themeData.colors.Primary,
            themeSecondary: themeData.colors.Secondary,
            themeTertiary: themeData.colors.Tertiary,
            themeLight: themeData.colors.Light,
            themeLighter: themeData.colors.Lighter,
            themeLighterAlt: themeData.colors.LighterAlt,
        },
        darkBrandColors: {
            themeDarker: themeData.colors.DarkTheme.Darker,
            themeDark: themeData.colors.DarkTheme.Dark,
            themeDarkAlt: themeData.colors.DarkTheme.DarkAlt,
            themePrimary: themeData.colors.DarkTheme.Primary,
            themeSecondary: themeData.colors.DarkTheme.Secondary,
            themeTertiary: themeData.colors.DarkTheme.Tertiary,
            themeLight: themeData.colors.DarkTheme.Light,
            themeLighter: themeData.colors.DarkTheme.Lighter,
            themeLighterAlt: themeData.colors.DarkTheme.LighterAlt,
        },
        overridePaletteMapping: (_a = themeData === null || themeData === void 0 ? void 0 : themeData.colorOverrides) === null || _a === void 0 ? void 0 : _a.palette,
        overrideTokenMapping: (_b = themeData === null || themeData === void 0 ? void 0 : themeData.colorOverrides) === null || _b === void 0 ? void 0 : _b.token,
    };
};
//# sourceMappingURL=officeStartThemeFromBase.js.map